import { Link } from "react-router-dom";
import { ArrowLeft, Lock, LockOpen, RefreshCw } from "lucide-react";
import { clock } from "../../lib/dash";
import { AccountMenu } from "../AccountMenu";

const GatePill = ({ gated }) => (
  <span
    data-testid="dash-gate-state"
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${gated ? "bg-amber-400/15 text-amber-300" : "bg-emerald-400/15 text-emerald-300"}`}
  >
    {gated ? <Lock className="h-3.5 w-3.5" /> : <LockOpen className="h-3.5 w-3.5" />}
    {gated === undefined ? "…" : gated ? "Site gated · invite only" : "Site open"}
  </span>
);

const PeriodPicker = ({ period, periods, onPeriod }) => (
  <div data-testid="dash-period" className="flex rounded-full bg-white/5 p-0.5">
    {Object.entries(periods || { today: "Today" }).map(([key, label]) => (
      <button
        key={key}
        type="button"
        data-testid={`dash-period-${key}`}
        onClick={() => onPeriod(key)}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${period === key ? "bg-primary text-primary-foreground" : "text-white/70 hover:text-white"}`}
      >
        {label}
      </button>
    ))}
  </div>
);

export const DashHeader = ({ gated, period, periods, onPeriod, updatedAt, onRefresh }) => {
  return (
    <header className="flex h-14 shrink-0 items-center gap-4 bg-[hsl(220_18%_11%)] px-4 text-[hsl(45_60%_96%)] lg:px-6">
      <Link to="/" data-testid="dash-back-to-studio" className="flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white">
        <ArrowLeft className="h-4 w-4" /> Studio
      </Link>
      <div className="flex items-baseline gap-2">
        <span className="font-heading text-lg font-extrabold tracking-tight">Duckify</span>
        <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-primary">Admin</span>
      </div>
      <GatePill gated={gated} />
      <div className="ml-auto hidden items-center gap-3 md:flex">
        <PeriodPicker period={period} periods={periods} onPeriod={onPeriod} />
        <button type="button" data-testid="dash-refresh" onClick={onRefresh} className="flex items-center gap-1.5 text-[11px] text-white/60 hover:text-white">
          <RefreshCw className="h-3.5 w-3.5" /> {updatedAt ? `Updated ${clock(updatedAt)}` : "Loading"}
        </button>
      </div>
      <AccountMenu testid="dash-initials" variant="dark" className="ml-auto md:ml-0" />
    </header>
  );
};
